module.exports = __webpack_public_path__ + "static/media/category13.9a926418.jpg";